import React, { useEffect, useRef, useState } from "react";

// Type-ahead combobox for picking a service catalog item while still
// allowing free text, so staff aren't blocked on one-off services that
// aren't in the catalog.
const ServiceTypeahead = ({ value, onChange, onSelect, services = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const query = (value || "").trim().toLowerCase();
  // With no query yet (just opened/focused), show the full list to browse;
  // once typing narrows it down, only matches are shown.
  const suggestions = services.filter((s) =>
    s.name.toLowerCase().includes(query),
  );

  return (
    <div className="position-relative" ref={containerRef}>
      <input
        type="text"
        className="form-control form-control-solid b-1"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setIsOpen(true);
        }}
        onFocus={() => setIsOpen(true)}
        autoComplete="off"
      />
      {isOpen && suggestions.length > 0 && (
        <ul
          className="list-group position-absolute w-100"
          style={{ zIndex: 1050, maxHeight: "220px", overflowY: "auto" }}
        >
          {suggestions.map((s) => (
            <li
              key={s._id}
              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(s);
                setIsOpen(false);
              }}
            >
              <span>
                {s.name}
                {s.category && (
                  <small className="text-muted ms-2">({s.category})</small>
                )}
              </span>
              <span className="text-muted small ms-2">
                {s.priceNote || `$${parseFloat(s.price || 0).toFixed(2)}`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ServiceTypeahead;
